export const projectsData = [
  {
    id: 1,
    name: "Voice Assistant",
    description: "AI-powered voice assistant with natural language processing",
    techStack: ["Python", "SpeechRecognition", "pyttsx3"],
    github: "https://github.com/atharv-patki/Jexi---AI-Voice-Assistant-.git",
    demo: null
  },
  {
    id: 2,
    name: "KPI Stock Dashboard", 
    description: "Real-time stock market dashboard with analytics",
    techStack: ["Python", "Matplotlib", "APIs", "Pandas"],
    github: "https://github.com/atharv-patki/MetricView.git",
    demo: null
  },
  {
    id: 3,
    name: "Skill-Based Study Buddy",
    description: "Personalized learning companion for skill development", 
    techStack: ["Python", "HTML", "SQLite", "CSS", "JS"],
    github: "https://github.com/atharv-patki/Skill-Based-Study-Buddy.git",
    demo: null
  },
  {
    id: 4,
    name: "Expense Tracker",
    description: "GUI app with pie charts and PDF export functionality",
    techStack: ["Python", "Tkinter", "Matplotlib", "ReportLab"], 
    github: "https://github.com/atharv-patki/python_mini_projects.git",
    demo: null
  },
  {
    id: 5,
    name: "InfraMind",
    description: "An intelligent cloud infrastructure monitoring platform built with AWS and Python to provide actionable infrastructure insights.",
    techStack: ["AWS", "Python", "Cloud Monitoring"],
    github: "https://github.com/atharv-patki/InfraMind",
    demo: null
  }
];
